<template>
  <div class="select select--input">
    <div class="dropdown dropdown--full-width">
      <Popper
        v-model:open="open"
        placement="bottom-end"
      >
        <template #trigger>
          <div
            class="dropdown__trigger"
            @click="open = !open"
          >
            <div class="select__trigger">
              <span class="select__label select__label--flex select__label--flat">
                <template v-if="modelValue">
                  <template v-if="modelValue.isNew">
                    <span class="menu-item__label-icon">
                      <UseSvg
                        class="icon icon--small"
                        name="plus"
                      />
                    </span>
                    <span class="menu-item__label">
                      {{ $t('operations.new_mine') }}
                    </span>
                  </template>
                  <span v-else>{{ modelValue.name }}</span>
                </template>
                <span
                  v-else
                  class="dim"
                >{{ $t('operations.no_mine') }}</span>
              </span>

              <span class="select__arrow">
                <UseSvg
                  class="icon icon--small"
                  name="arrow_down_16"
                />
              </span>
            </div>
          </div>
        </template>

        <div class="menu menu--dropdown">
          <ul class="menu__items">
            <li class="menu-item menu-item--dropdown">
              <button
                class="menu-item__link"
                type="button"
                @click="selectMine(null)"
              >
                <span class="menu-item__label dim">
                  {{ $t('operations.no_mine') }}
                </span>
              </button>
            </li>
            <li
              v-for="mine in mines"
              :key="mine.id"
              class="menu-item menu-item--dropdown"
            >
              <button
                class="menu-item__link"
                type="button"
                @click="selectMine(mine)"
              >
                <span class="menu-item__label">
                  {{ mine.name }}
                </span>
              </button>
            </li>
          </ul>
        </div>
      </Popper>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import Popper from '@/components/generic/popper.vue';
import UseSvg from '@/components/generic/use_svg.vue';

defineProps({
  modelValue: { type: Object, default: null },
  mines: { type: Array, default: () => [] },
});
const emit = defineEmits(['update:modelValue']);

const open = ref(false);

function selectMine(mine) {
  emit('update:modelValue', mine);
  open.value = false;
}
</script>
